import { render } from "./info_busyo.vue?vue&type=template&id=b10f35a4"
import script from "./info_busyo.vue?vue&type=script&lang=js"
export * from "./info_busyo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__